import { Form, Modal, message } from "antd";
import { useEffect } from "react";
import { useLoading } from "../../context/loadingContext";
import UpdateMerchantProfile from "../../functions/merchant/updateMerchantProfile";
import MerchantOrganizationFormFields from "../merchant/merchantOrganizationFormFields";
import { getMerchantId } from "service/storage";

const MerchantOrganizationEditModal = ({ open, close, merchant, onSaved }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const merchantId = getMerchantId();

  useEffect(() => {
    if (!open || !merchant) return;
    form.setFieldsValue({
      name: merchant.name,
      register: merchant.register || undefined,
      phone: merchant.phone,
      phone2: merchant.phone2 || undefined,
      email: merchant.email,
      address: merchant.address || undefined,
    });
  }, [open, merchant, form]);

  const onFinish = async (values) => {
    showLoading();
    try {
      const response = await UpdateMerchantProfile(merchantId, values);
      if (response?.success) {
        message.success("Хадгалагдлаа");
        onSaved(response.data);
        close();
      }
    } finally {
      hideLoading();
    }
  };

  return (
    <Modal
      title="Байгууллагын бүртгэл засах"
      open={open}
      onCancel={close}
      onOk={() => form.submit()}
      okText="Хадгалах"
      cancelText="Болих"
      destroyOnClose
      width={640}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <MerchantOrganizationFormFields />
      </Form>
    </Modal>
  );
};

export default MerchantOrganizationEditModal;
